export default "__VITE_ASSET__WbDg4Gfh__"